import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-auto"
}
const _hoisted_2 = { class: "card py-2 px-2" }
const _hoisted_3 = { class: "table table-striped" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_modal = _resolveComponent("modal")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[32] || (_cache[32] = _createElementVNode("div", null, [
      _createElementVNode("h1", null, "Institutions")
    ], -1)),
    (!_ctx.loading && !_ctx.has_error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _cache[18] || (_cache[18] = _createElementVNode("thead", { class: "thead-dark" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "header-row py-2 px-2" }, "Name"),
                  _createElementVNode("th", { class: "header-row py-2 px-2" }, "Royalty Rate"),
                  _createElementVNode("th", { class: "header-row py-2 px-2" }, "Edit"),
                  _createElementVNode("th", { class: "header-row py-2" }, "Delete")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutions, (institution) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: institution.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(institution.name), 1),
                    _createElementVNode("td", null, "$" + _toDisplayString(institution.royalty_rate.toFixed(2)), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-xs btn-primary",
                        onClick: ($event: any) => (_ctx.updateInstitution(institution))
                      }, _cache[16] || (_cache[16] = [
                        _createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
                      ]), 8, _hoisted_4)
                    ]),
                    _createElementVNode("td", null, [
                      (institution.deletable)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-xs btn-primary",
                            onClick: ($event: any) => (_ctx.deleteInstitution(institution))
                          }, _cache[17] || (_cache[17] = [
                            _createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
                          ]), 8, _hoisted_5))
                        : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (!_ctx.institutions.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[19] || (_cache[19] = [
                  _createElementVNode("p", null, "No institutions in system.", -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn btn-md btn-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createInstitution && _ctx.createInstitution(...args)))
              }, "Create Institution")
            ])
          ])
        ]))
      : (!_ctx.loading && _ctx.has_error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[20] || (_cache[20] = _createElementVNode("h3", null, "Error", -1)),
            _createElementVNode("p", { innerHTML: _ctx.error_msg }, null, 8, _hoisted_9)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      modelValue: _ctx.show_create_modal,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.show_create_modal) = $event))
    }, {
      header: _withCtx(() => _cache[21] || (_cache[21] = [
        _createTextVNode("Create Institution")
      ])),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", null, [
            _cache[22] || (_cache[22] = _createTextVNode("Name")),
            _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.create_name) = $event)),
              maxlength: "255",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearError('create_name')))
            }, null, 544), [
              [_vModelText, _ctx.create_name]
            ])
          ]),
          (_ctx.create_name_error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.create_name_error), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", null, [
            _cache[24] || (_cache[24] = _createTextVNode("Royalty Rate")),
            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_currency_input, {
              modelValue: _ctx.create_royalty_rate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.create_royalty_rate) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "btn btn-md btn-primary float-end ms-2",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createInstitutionSubmit && _ctx.createInstitutionSubmit(...args)))
          }, "Create"),
          _createElementVNode("button", {
            class: "btn btn-md btn-secondary float-end",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.createInstitution && _ctx.createInstitution(...args)))
          }, "Cancel")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_modal, {
      modelValue: _ctx.show_delete_modal,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.show_delete_modal) = $event))
    }, {
      header: _withCtx(() => _cache[26] || (_cache[26] = [
        _createTextVNode("Delete Institution")
      ])),
      default: _withCtx(() => [
        _createElementVNode("p", null, "Are you sure you would like to delete " + _toDisplayString(_ctx.delete_institution.name) + "?", 1),
        _createElementVNode("button", {
          class: "btn btn-md btn-primary float-end ms-2",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.deleteInstitutionSubmit && _ctx.deleteInstitutionSubmit(...args)))
        }, "Delete"),
        _createElementVNode("button", {
          class: "btn btn-md btn-secondary float-end",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.deleteInstitution && _ctx.deleteInstitution(...args)))
        }, "Cancel")
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_modal, {
      modelValue: _ctx.show_update_modal,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.show_update_modal) = $event))
    }, {
      header: _withCtx(() => _cache[27] || (_cache[27] = [
        _createTextVNode("Edit Institution")
      ])),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", null, [
            _cache[28] || (_cache[28] = _createTextVNode("Name")),
            _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.update_name) = $event)),
              maxlength: "255",
              onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearError('update_name')))
            }, null, 544), [
              [_vModelText, _ctx.update_name]
            ])
          ]),
          (_ctx.update_name_error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.update_name_error), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("label", null, [
            _cache[30] || (_cache[30] = _createTextVNode("Royalty Rate")),
            _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_currency_input, {
              modelValue: _ctx.update_royalty_rate,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.update_royalty_rate) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            class: "btn btn-md btn-primary float-end ms-2",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.updateInstitutionSubmit && _ctx.updateInstitutionSubmit(...args)))
          }, "Update"),
          _createElementVNode("button", {
            class: "btn btn-md btn-secondary float-end",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.updateInstitution && _ctx.updateInstitution(...args)))
          }, "Cancel")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}